export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SET_METADATA = 'SET_METADATA';
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';

export const NAVIGATE = 'NAVIGATE';
export const VIEW_NOTIFICATIONS = 'VIEW_NOTIFICATIONS';